'use client';

import React from 'react';

const brands = [
  { name: 'Mercedes Benz', color: '#C41E3A', emoji: '⭐' },
  { name: 'MAN Trucks', color: '#1B3A8C', emoji: '🔧' },
  { name: 'Scania', color: '#F5A623', emoji: '⚙️' },
  { name: 'Volvo', color: '#C41E3A', emoji: '🛞' },
  { name: 'BPW Trailers', color: '#1B3A8C', emoji: '🔩' },
  { name: 'HOWO', color: '#F5A623', emoji: '🚛' },
  { name: 'Beiben', color: '#C41E3A', emoji: '🏗️' },
  { name: 'DAF Trucks', color: '#1B3A8C', emoji: '🔧' },
  { name: 'Iveco', color: '#F5A623', emoji: '⚙️' },
  { name: 'Renault Trucks', color: '#C41E3A', emoji: '🛞' },
  { name: 'BMW', color: '#1B3A8C', emoji: '🚗' },
  { name: 'Volkswagen', color: '#F5A623', emoji: '🔩' },
  { name: 'Ford', color: '#C41E3A', emoji: '🚙' },
  { name: 'Toyota', color: '#1B3A8C', emoji: '🏎️' },
];

export default function BrandsMarquee() {
  const doubled = [...brands, ...brands];

  return (
    <section id="brands" className="py-20 bg-white relative" style={{ overflow: 'hidden' }}>
      <hr className="section-divider" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center mb-12 pt-12">
        <p className="text-brand-red text-xs font-heading font-black uppercase tracking-widest mb-3">
          Trusted Brands
        </p>
        <h2 className="font-heading font-black text-brand-dark text-3xl md:text-5xl tracking-tight mb-4">
          Parts for Every Major Brand
        </h2>
        <p className="text-brand-muted font-body max-w-xl mx-auto text-sm sm:text-base">
          From heavy-duty European trucks to Chinese commercial vehicles — we stock genuine and quality aftermarket parts for all major brands operating in East Africa.
        </p>
      </div>

      {/* Marquee wrapper with fade edges */}
      <div className="marquee-section-wrapper">
        {/* Marquee Row 1 */}
        <div className="relative overflow-hidden mb-4">
          <div className="marquee-track" style={{ animation: 'marquee-scroll 35s linear infinite' }}>
            {doubled?.map((brand, i) => (
              <div
                key={`brand-a-${i}`}
                className="inline-flex items-center gap-3 mx-3 sm:mx-5 px-4 sm:px-6 py-3 rounded-full border border-brand-border bg-white shadow-card hover:shadow-card-hover transition-all cursor-default flex-shrink-0"
                style={{ borderLeft: `3px solid ${brand?.color}` }}
              >
                <span className="text-lg sm:text-xl">{brand?.emoji}</span>
                <span className="font-heading font-bold text-brand-dark text-xs sm:text-sm whitespace-nowrap">
                  {brand?.name}
                </span>
              </div>
            ))}
          </div>
        </div>
        {/* Marquee Row 2 — reversed */}
        <div className="relative overflow-hidden">
          <div
            className="marquee-track"
            style={{ animation: 'marquee-scroll 45s linear infinite reverse' }}
          >
            {[...doubled]?.reverse()?.map((brand, i) => (
              <div
                key={`brand-b-${i}`}
                className="inline-flex items-center gap-3 mx-3 sm:mx-5 px-4 sm:px-6 py-3 rounded-full border border-brand-border bg-brand-bg hover:bg-white transition-all cursor-default flex-shrink-0"
                style={{ borderLeft: `3px solid ${brand?.color}` }}
              >
                <span className="text-lg sm:text-xl">{brand?.emoji}</span>
                <span className="font-heading font-bold text-brand-muted text-xs sm:text-sm whitespace-nowrap">
                  {brand?.name}
                </span>
              </div>
            ))}
          </div>
        </div>
        {/* Fade edges */}
        <div className="marquee-fade-left" aria-hidden="true" />
        <div className="marquee-fade-right" aria-hidden="true" />
      </div>
    </section>
  );
}